import { render } from "./tMoney.vue?vue&type=template&id=3c37167c&ts=true"
import script from "./tMoney.vue?vue&type=script&lang=ts"
export * from "./tMoney.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__